import { useState } from 'react'
import { useTranslation } from 'react-i18next'
//Components
import ScrollSnap from '../ScrollSnap'
import ServiceItem from './ServiceItem'
import ShortArrow from '../svg/ShortArrow'
//Img
import circuitos from '../../assets/images/icons/circuitos.svg'
import experiencias from '../../assets/images/icons/experiencias.svg'
import lgbt from '../../assets/images/icons/lgbt.svg'
import aventuras from '../../assets/images/icons/aventuras.svg'
import cruceros from '../../assets/images/icons/cruceros.svg'
import deportes from '../../assets/images/icons/deportes.svg'
import mice from '../../assets/images/icons/mice.svg'

const ServicesSlider = () => {
    const { t } = useTranslation()

    const [nextActive, setNextActive] = useState(false)
    const [prevActive, setPrevActive] = useState(false)

    //Estado para ocultar la flecha de ir a la derecha cuando se llego al final del scroll snap
    const [endOfSlider, setEndOfSlider] = useState(false)
    const [startOfSlider, setStartOfSlider] = useState(true)

    return (
        <div className="service-slider">
            <div className="left-fade-wrapper"></div>

            <ScrollSnap
                type="mandatory"
                goNext={nextActive}
                goPrev={prevActive}
                setEndOfSlider={setEndOfSlider}
                setStartOfSlider={setStartOfSlider}
                align="start"
            >
                <ServiceItem
                    icon={circuitos}
                    title={t('home.services.circuitos.title')}
                    copy={t('home.services.circuitos.copy')}
                    link="#"
                />
                <ServiceItem
                    icon={experiencias}
                    title={t('home.services.experiencias.title')}
                    copy={t('home.services.experiencias.copy')}
                    link="#"
                />
                <ServiceItem
                    icon={lgbt}
                    title={t('home.services.lgbt.title')}
                    copy={t('home.services.lgbt.copy')}
                    link="#"
                />
                <ServiceItem
                    icon={aventuras}
                    title={t('home.services.aventuras.title')}
                    copy={t('home.services.aventuras.copy')}
                    link="#"
                />
                <ServiceItem
                    icon={cruceros}
                    title={t('home.services.cruceros.title')}
                    copy={t('home.services.cruceros.copy')}
                    link="#"
                />
                <ServiceItem
                    icon={deportes}
                    title={t('home.services.deportes.title')}
                    copy={t('home.services.deportes.copy')}
                    link="#"
                />
                <ServiceItem
                    icon={mice}
                    title={t('home.services.mice.title')}
                    copy={t('home.services.mice.copy')}
                    link="#"
                />
            </ScrollSnap>

            {!endOfSlider && (
                <div
                    className="arrow-wrapper"
                    role="button"
                    aria-label="Bajar - Go down"
                    onMouseDown={() => setNextActive(true)}
                    onMouseUp={() => setNextActive(false)}
                >
                    <ShortArrow />
                </div>
            )}

            {!startOfSlider && (
                <div
                    className="arrow-wrapper left-arrow"
                    role="button"
                    aria-label="Bajar - Go down"
                    onMouseDown={() => setPrevActive(true)}
                    onMouseUp={() => setPrevActive(false)}
                >
                    <ShortArrow />
                </div>
            )}
        </div>
    )
}

export default ServicesSlider
